import { render, staticRenderFns } from "./CafeCarousel.vue?vue&type=template&id=1b2a4bcb&"
import script from "./CafeCarousel.vue?vue&type=script&lang=js&"
export * from "./CafeCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports